module.exports = __webpack_public_path__ + "img/store_image_cutaway_01.8e672460.png";